module.exports = __webpack_public_path__ + "static/media/notification.9fc27035.mp3";